"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function usePrevious(value) {
    var ref = react_1.default.useRef();
    react_1.default.useEffect(function () {
        ref.current = value;
    });
    return ref.current;
}
exports.default = usePrevious;
//# sourceMappingURL=index.js.map